/**
 * The service action types.
 */
export enum ServiceActionType {

	/**
	 * The signature action type.
	 */
	Signature = 0,

	/**
	 * The documents action type.
	 */
	Documents = 1,

	/**
	 * The pictures action type.
	 */
	Pictures = 2,

	/**
	 * The over, short and damaged action type.
	 */
	OSD = 3,

	/**
	 * The signer action type.
	 */
	Signer = 4,
}